var render, staticRenderFns
import script from "./PurchaseOrderAdmin.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f8a372",
  null
  
)

export default component.exports